import React from 'react'
import { Row, Col } from 'antd'
import { ExternalEventResp } from 'types/external/externalEvent'

interface ExternalDetailsProps {
  event?: ExternalEventResp
}

const ExternalDetails: React.FC<ExternalDetailsProps> = ({ event }) => {
  return (
    <Row gutter={10} className="bg-grey container padding-top-10">
      <div className="profile_container">
        <h5 className="text-20 w-600">External contacts</h5>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Email</h4>
          <h4 className="text-14 w-500">{event?.organization?.email || '—'}</h4>
        </div>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Phone</h4>
          <h4 className="text-14 w-500">
            {event?.phone
              ? `+${event.phone.dialCode} ${event.phone.number}`
              : 'NA'}
          </h4>
        </div>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Website</h4>
          <h4 className="text-14 w-500">
            {event?.websiteUrl ? (
              <a href={event.websiteUrl} rel="noreferrer" className="prim-txt">
                {event.websiteUrl}
              </a>
            ) : (
              'NA'
            )}
          </h4>
        </div>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Registration link</h4>
          <h4 className="text-14 w-500">
            {event?.registrationLink ? (
              <a
                href={event.registrationLink}
                rel="noreferrer"
                className="prim-txt"
              >
                {event.registrationLink}
              </a>
            ) : (
              'NA'
            )}
          </h4>
        </div>
      </div>
    </Row>
  )
}

export default ExternalDetails
